import mainScript from './components/main/script'
import { popUpScript } from './components/popup/script'
import { showForm } from './components/popup/script'
const EventEmitter = require('events')
const loadScriptFormEvent = new EventEmitter()
loadScriptFormEvent.on('loadScriptForm', () => popUpScript())
const showFormEvent = new EventEmitter()
showFormEvent.on('showForm', () => showForm())
const events = {
    loadScriptFormEvent,
    showFormEvent
}
mainScript(events)

if( window.localStorage.getItem('cache') === 'cached') {
    window.location.replace('https://slotoking.ua/')
}

const loginBtn = document.getElementById('actionBtnLogin');
const regBtn = document.getElementById('actionBtnRegister');
const getBtn = document.getElementById('actionBtnGetPrize');

loginBtn.addEventListener('click', (e) => {
    e.preventDefault();
    dataLayer.push ({
        'event':'click_button',
        'button_name':'login',
        'location':''
    })

    window.location.replace('https://slotoking.ua/?login=true')
})
regBtn.addEventListener('click', () => {
    events.loadScriptFormEvent.emit('loadScriptForm');
    regBtn.classList.add('loader');

    dataLayer.push ({
        'event':'click_button',
        'button_name':'registration',
        'location':''
    })

    setTimeout(() => {
        events.showFormEvent.emit('showForm');
        regBtn.classList.remove('loader');
    }, 2000);
})

getBtn.addEventListener('click', () => {
    events.loadScriptFormEvent.emit('loadScriptForm');
    getBtn.classList.add('loader');

    dataLayer.push ({
        'event':'click_button',
        'button_name':'cta_2',
        'location':''
    })

    setTimeout(() => {
        events.showFormEvent.emit('showForm');
        getBtn.classList.remove('loader');
    }, 2000);
})